// extracted by mini-css-extract-plugin
export var card = "InfoCard-module--card--b368b";